import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { IClinic } from '../../../../models/clinic.model';
import { ISibasiHTTPResponse } from '../../../../models/sibasiHTTPResponse.model';

@Injectable({
  providedIn: 'root'
})
export class ClinicService {

  constructor(
    private httpClient: HttpClient
  ) { }

  getAllClinics(): Observable<ISibasiHTTPResponse<IClinic[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<IClinic[]>>(`${environment.api_url}/clinic/all`);
  }

  createClinic(clinic: IClinic): Observable<ISibasiHTTPResponse<IClinic>> {
    return this.httpClient.post<ISibasiHTTPResponse<IClinic>>(`${environment.api_url}/clinic/new`, clinic);
  }

  updateClinic(clinic: IClinic, clinicId: string): Observable<ISibasiHTTPResponse<IClinic>> {
    return this.httpClient
    .post<ISibasiHTTPResponse<IClinic>>(`${environment.api_url}/clinic/update/${clinicId}`, clinic);
  }

  // deleteClinic(clinicId: string): Observable<ISibasiHTTPResponse<IClinic>> {
  //   return this.httpClient.delete<ISibasiHTTPResponse<IClinic>>(`${environment.api_url}/clinic/delete/${clinicId}`);
  // }

  deleteClinic(clinicId: string): Observable<ISibasiHTTPResponse<IClinic>> {
    return this.httpClient.delete<ISibasiHTTPResponse<IClinic>>(`${environment.api_url}/clinic/slateforDeletion/${clinicId}`);
  }

  restoreDeletedClinic(clinicId: string): Observable<ISibasiHTTPResponse<IClinic>> {
    return this.httpClient.delete<ISibasiHTTPResponse<IClinic>>(`${environment.api_url}/clinic/unslateforDeletion/${clinicId}`);
  }

  getDeletedClinics(): Observable<ISibasiHTTPResponse<IClinic[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<IClinic[]>>(`${environment.api_url}/clinic/allDeleted`);
  }

  getClinicById(clinicId: string): Observable<ISibasiHTTPResponse<IClinic>> {
    return this.httpClient.get<ISibasiHTTPResponse<IClinic>>(`${environment.api_url}/clinic/${clinicId}`);
  }
  getPaginatedClinics(pagination?: any): Observable<ISibasiHTTPResponse<IClinic[]>> {
    return this.httpClient
    .post<ISibasiHTTPResponse<IClinic[]>>(`${environment.api_url}/clinic/allClinicsPaginated`, pagination ? pagination : {});
  }
  getAllClinicsCount(): Observable<ISibasiHTTPResponse<number>> {
    return this.httpClient.get<ISibasiHTTPResponse<number>>(`${environment.api_url}/clinic/allClinicCount`);
  }
}
